import React from 'react';
import styles from '../AddProduct.module.css';
import { handlePriceChange, PRODUCT_CODE_MAX } from '../HelperFunction';

function PricingInventory({
    buyPrice,
    setBuyPrice,
    sellingPrice,
    setSellingPrice,
    compare,
    setCompare,
    pCode,
    setPCode,
    colorName,
    setColorName,
    quantity,
    setQuantity,
    maxOrderQty,
    setMaxOrderQty,
    checkvariation,
    errorFields,
    setErrorFields,
    handleFieldChange,
}) {
    return (
        <div className={styles['AddProduct-card']}>
            <h2 className={styles['AddProduct-card-title']}>Pricing</h2>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Cost price{' '}
                    <span className={styles['AddProduct-required']}>*</span>
                </label>
                <input
                    onChange={handlePriceChange(
                        'buyPrice',
                        setBuyPrice,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={`${styles.form__input_add} ${
                        errorFields.buyPrice ? styles['error-field'] : ''
                    }`}
                    placeholder="0.00"
                    value={buyPrice}
                />
                {errorFields.buyPrice && (
                    <div className={styles['error-text']}>
                        Cost price is required
                    </div>
                )}
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Selling price{' '}
                    <span className={styles['AddProduct-required']}>*</span>
                </label>
                <input
                    onChange={handlePriceChange(
                        'sellingPrice',
                        setSellingPrice,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={`${styles.form__input_add} ${
                        errorFields.sellingPrice ? styles['error-field'] : ''
                    }`}
                    placeholder="0.00"
                    value={sellingPrice}
                />
                {errorFields.sellingPrice && (
                    <div className={styles['error-text']}>
                        Selling price is required
                    </div>
                )}
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Compare at price
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (Optional)
                    </span>
                </label>
                <input
                    onChange={handlePriceChange(
                        'compare',
                        setCompare,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    className={styles.form__input_add}
                    placeholder="0.00"
                    value={compare}
                />
                <div className={styles['AddProduct-help-text']}>
                    Show a "was" price on your product
                </div>
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    SKU <span className={styles['AddProduct-required']}>*</span>
                </label>
                <input
                    onChange={handleFieldChange(
                        'pCode',
                        setPCode,
                        errorFields,
                        setErrorFields
                    )}
                    type="text"
                    maxLength={PRODUCT_CODE_MAX}
                    className={`${styles.form__input_add} ${
                        errorFields.pCode ? styles['error-field'] : ''
                    }`}
                    placeholder="e.g., CDR-001"
                    value={pCode}
                />
                {errorFields.pCode ? (
                    <div className={styles['error-text']}>
                        {errorFields.pCode === 'long'
                            ? `SKU can be at most ${PRODUCT_CODE_MAX} characters`
                            : 'SKU is required'}
                    </div>
                ) : (
                    <div className={styles['AddProduct-help-text']}>
                        Up to {PRODUCT_CODE_MAX} characters, e.g. CDR-001 or a
                        barcode. Shown on the product page as প্রোডাক্ট কোড.
                    </div>
                )}
            </div>

            <div className={styles['AddProduct-form-group']}>
                <label className={styles['AddProduct-label']}>
                    Max order quantity
                    <span className={styles['AddProduct-label-optional']}>
                        {' '}
                        (per order)
                    </span>
                </label>
                <input
                    onChange={(e) =>
                        setMaxOrderQty(e.target.value.replace(/[^0-9]/g, ''))
                    }
                    type="text"
                    inputMode="numeric"
                    className={styles.form__input_add}
                    placeholder="5"
                    value={maxOrderQty}
                />
                <div className={styles['AddProduct-help-text']}>
                    The most units of this product a customer can put in one
                    order. Default 5.
                </div>
            </div>
            {checkvariation === 'no' && (
                <>
                    <div className={styles['AddProduct-form-group']}>
                        <label className={styles['AddProduct-label']}>
                            Color name{' '}
                            <span className={styles['AddProduct-required']}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handleFieldChange(
                                'colorName',
                                setColorName,
                                errorFields,
                                setErrorFields
                            )}
                            type="text"
                            className={`${styles.form__input_add} ${
                                errorFields.colorName
                                    ? styles['error-field']
                                    : ''
                            }`}
                            placeholder="e.g., Black, White, Red"
                            value={colorName}
                        />
                        {errorFields.colorName && (
                            <div className={styles['error-text']}>
                                Color name is required
                            </div>
                        )}
                    </div>

                    <div className={styles['AddProduct-form-group']}>
                        <label className={styles['AddProduct-label']}>
                            Quantity{' '}
                            <span className={styles['AddProduct-required']}>
                                *
                            </span>
                        </label>
                        <input
                            onChange={handlePriceChange(
                                'quantity',
                                setQuantity,
                                errorFields,
                                setErrorFields
                            )}
                            type="text"
                            className={`${styles.form__input_add} ${
                                errorFields.quantity
                                    ? styles['error-field']
                                    : ''
                            }`}
                            placeholder="0"
                            value={quantity}
                        />
                        {errorFields.quantity && (
                            <div className={styles['error-text']}>
                                Quantity is required
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default PricingInventory;
